export const buildFilterParams = (filters) => {
  const params = new URLSearchParams();
  Object.entries(filters || {}).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => params.append(`${key}[]`, item));
    } else if (value !== undefined && value !== null) {
      params.append(key, value);
    }
  });
  return params;
};
